"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const StreamMessageError_1 = __importDefault(require("./StreamMessageError"));
class InvalidJsonError extends StreamMessageError_1.default {
    constructor(streamId, parseError, streamMessage) {
        super(`Invalid JSON in stream ${streamId}: ${parseError}`, streamMessage);
        this.parseError = parseError;
    }
}
exports.default = InvalidJsonError;
//# sourceMappingURL=InvalidJsonError.js.map